import { render, staticRenderFns } from "./UserCard.vue?vue&type=template&id=6dd092f3&scoped=true"
import script from "./UserCard.vue?vue&type=script&lang=js"
export * from "./UserCard.vue?vue&type=script&lang=js"
import style0 from "./UserCard.vue?vue&type=style&index=0&id=6dd092f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@6.10.0_vue-template-compiler@2.7.16_webpack@5.91.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd092f3",
  null
  
)

export default component.exports